import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    ExcelExportButton,
    FilterBar,
    FilterItemConfig,
} from '@/components/ui/data-table-customized'
import { ColumnMapping } from '@/components/ExcelExportModal'
import { Income } from '../../types'
import { DataTableColumn } from '@/components/ui/data-table-customized'
import { Control } from 'react-hook-form'

interface IncomesViewProps {
    incomes: Income[]
    pagination?: { total: number }
    stateComponent: React.ReactNode
    isFetching: boolean
    isLoading: boolean
    columns: DataTableColumn<Income>[]
    filterItems: FilterItemConfig[]
    control: Control<any>
    setFilter: (key: any, value: any) => void
    setFilters?: (updates: Record<string, any>) => void
    searchInputProps: { value: string; onChange: (value: string) => void }
    params: {
        sort_by: string
        sort_order: 'asc' | 'desc'
        page: number
        page_size: number
    }
    queryParams: Record<string, any>
    excelColumns: ColumnMapping[]
    handleSortChange: (sortBy: string, sortOrder: 'asc' | 'desc') => void
    handlePageChange: (page: number) => void
    handlePageSizeChange: (pageSize: number) => void
    t: (key: string) => string
    storageKey?: string
}

const IncomesView = ({
    incomes,
    pagination,
    stateComponent,
    isFetching,
    isLoading,
    columns,
    filterItems,
    control,
    setFilter,
    setFilters,
    searchInputProps,
    params,
    queryParams,
    excelColumns,
    handleSortChange,
    handlePageChange,
    handlePageSizeChange,
    t,
    storageKey = 'income-list',
}: IncomesViewProps) => {
    return (
        <Paper className="space-y-2">
            <FilterBar
                control={control}
                setFilter={setFilter}
                setFilters={setFilters}
                items={filterItems}
                hideSearch
            />

            {stateComponent || (
                <DataTableCustomized
                    columns={columns}
                    rows={incomes}
                    rowKey={(row) => row.invoice_item_id}
                    resizable
                    size="small"
                    loading={isLoading}
                    isFetching={isFetching && !isLoading}
                    sorting={{
                        sortBy: params.sort_by,
                        sortOrder: params.sort_order,
                        onSortChange: handleSortChange,
                    }}
                    pagination={{
                        page: params.page,
                        pageSize: params.page_size,
                        total: pagination?.total || 0,
                        onPageChange: handlePageChange,
                        onPageSizeChange: handlePageSizeChange,
                    }}
                    toolbar={{
                        search: {
                            ...searchInputProps,
                            placeholder: t('search'),
                        },
                        settings: {
                            show: true,
                            storageKey,
                            actionComponents: [
                                <ExcelExportButton
                                    key="export"
                                    apiEndpoint="reports/employees/incomes"
                                    columns={excelColumns}
                                    queryParams={queryParams}
                                    feature="report"
                                />,
                            ],
                        },
                    }}
                />
            )}
        </Paper>
    )
}

export default IncomesView
